var exports = {
  "Mv": "TextareaButtons.module__invisibleTrigger___U3ZQQT",
  "IO": "TextareaButtons.module__mobileRightButtonContainer___U3ZQQT",
  "Pc": "TextareaButtons.module__mobileRightButtonSlot___U3ZQQT",
};

module.exports = exports;
